// Liene 父の日 2026 LP - Interactive JS
(function() {
  'use strict';
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  function init() {

document.querySelectorAll('.faq-item').forEach(item => {
  item.addEventListener('click', () => {
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

function updateCountdown() {
  const now = new Date();

  // ===== Hero countdown =====
  const heroEl = document.querySelector('.countdown[data-countdown-target]');
  if (heroEl) {
    const raw = (heroEl.getAttribute('data-countdown-target') || '').trim().replace(' ', 'T');
    const target = new Date(raw);
    if (!isNaN(target)) {
      const diff = target - now;
      const nums = heroEl.querySelectorAll('.count-num');
      if (nums.length >= 4) {
        if (diff <= 0) {
          nums[0].textContent = '00';
          nums[1].textContent = '00';
          nums[2].textContent = '00';
          nums[3].textContent = '00';
        } else {
          const days = Math.floor(diff / 86400000);
          const hours = Math.floor((diff % 86400000) / 3600000);
          const mins = Math.floor((diff % 3600000) / 60000);
          const secs = Math.floor((diff % 60000) / 1000);
          nums[0].textContent = String(days).padStart(2, '0');
          nums[1].textContent = String(hours).padStart(2, '0');
          nums[2].textContent = String(mins).padStart(2, '0');
          nums[3].textContent = String(secs).padStart(2, '0');
        }
      }
    }
  }

  // ===== Bundle / Collection countdown =====
  const bundleEl = document.querySelector('.bundle-countdown[data-countdown-target]');
  if (bundleEl) {
    const raw = (bundleEl.getAttribute('data-countdown-target') || '').trim().replace(' ', 'T');
    const target = new Date(raw);
    if (!isNaN(target)) {
      const bDiff = target - now;
      const bd = bundleEl.querySelector('.bundle-d');
      const bh = bundleEl.querySelector('.bundle-h');
      const bm = bundleEl.querySelector('.bundle-m');
      const bs = bundleEl.querySelector('.bundle-s');
      if (bDiff <= 0) {
        if (bd) bd.textContent = '00';
        if (bh) bh.textContent = '00';
        if (bm) bm.textContent = '00';
        if (bs) bs.textContent = '00';
      } else {
        const bD = Math.floor(bDiff / 86400000);
        const bH = Math.floor((bDiff % 86400000) / 3600000);
        const bM = Math.floor((bDiff % 3600000) / 60000);
        const bS = Math.floor((bDiff % 60000) / 1000);
        if (bd) bd.textContent = String(bD).padStart(2, '0');
        if (bh) bh.textContent = String(bH).padStart(2, '0');
        if (bm) bm.textContent = String(bM).padStart(2, '0');
        if (bs) bs.textContent = String(bS).padStart(2, '0');
      }
    }
  }
}
updateCountdown();
setInterval(updateCountdown, 1000);

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, {threshold: 0.1});

document.querySelectorAll('.pick-card, .benefit, .budget-card, .tier, .product-card, .persona, .step, .review-card, .bundle-card, .coupon, .gallery-item').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(30px)';
  el.style.transition = 'opacity .8s ease-out, transform .8s ease-out';
  observer.observe(el);
});

// ============ Product image upload handler ============
// Allows users to click on product images and replace them with their own uploads.
// Uploaded images are stored in-memory (lost on reload). For production, integrate with backend.
document.querySelectorAll('.product-image-upload input[type="file"]').forEach(input => {
  input.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('ファイルサイズは5MB以下にしてください');
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const imageContainer = e.target.closest('.product-image');
      
      // Remove old SVG/img
      const oldSvg = imageContainer.querySelector('svg[role="img"]');
      const oldImg = imageContainer.querySelector('img.product-uploaded');
      if (oldSvg) oldSvg.style.display = 'none';
      if (oldImg) oldImg.remove();
      
      // Create new image
      const img = document.createElement('img');
      img.src = event.target.result;
      img.className = 'product-uploaded';
      img.alt = imageContainer.dataset.product || 'Product image';
      img.loading = 'lazy';
      
      // Insert before the upload label
      const uploadLabel = imageContainer.querySelector('.product-image-upload');
      imageContainer.insertBefore(img, uploadLabel);
      
      // Remove placeholder flag
      imageContainer.removeAttribute('data-placeholder');
    };
    reader.readAsDataURL(file);
  });
});

// ============ Universal image upload (polaroids, memory frames, bundles) ============
document.querySelectorAll('.editable-overlay input[type="file"]').forEach(input => {
  input.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (file.size > 5 * 1024 * 1024) {
      alert('ファイルサイズは5MB以下にしてください');
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const container = e.target.closest('.editable-image, .bundle-visual');
      if (!container) return;
      
      // Hide default SVG illustration
      const defaultSvg = container.querySelector(':scope > svg:not(.editable-overlay svg)');
      if (defaultSvg) defaultSvg.style.display = 'none';
      
      // Remove any previously uploaded image
      const oldImg = container.querySelector('img.editable-uploaded');
      if (oldImg) oldImg.remove();
      
      // Create new image
      const img = document.createElement('img');
      img.src = event.target.result;
      img.className = 'editable-uploaded';
      img.alt = container.dataset.polaroid || container.dataset.bundle || 'Custom image';
      img.loading = 'lazy';
      
      // Insert before overlay
      const overlay = container.querySelector('.editable-overlay');
      container.insertBefore(img, overlay);
    };
    reader.readAsDataURL(file);
  });
});

// ============ Gallery masonry image upload ============
document.querySelectorAll('.gi-upload input[type="file"]').forEach(input => {
  input.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (file.size > 5 * 1024 * 1024) {
      alert('ファイルサイズは5MB以下にしてください');
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const galleryItem = e.target.closest('.gallery-item');
      if (!galleryItem) return;
      
      // Hide default SVG illustration
      const defaultSvg = galleryItem.querySelector('svg.gi-svg');
      if (defaultSvg) defaultSvg.style.display = 'none';
      
      // Remove any previously uploaded image
      const oldImg = galleryItem.querySelector('img.editable-uploaded');
      if (oldImg) oldImg.remove();
      
      // Create new image
      const img = document.createElement('img');
      img.src = event.target.result;
      img.className = 'editable-uploaded';
      img.alt = galleryItem.dataset.gallery || 'User creation';
      img.loading = 'lazy';
      
      // Insert at the beginning so it's behind label/overlay/upload
      galleryItem.insertBefore(img, galleryItem.firstChild);
    };
    reader.readAsDataURL(file);
  });
});

  }
})();
